import { CustomThemeProvider } from 'sonata-react-components';

type Props = {
  children: React.ReactNode;
  theme: 'dark' | 'light';
};

export default function Theme({ children, theme }: Props) {
  return <CustomThemeProvider themeContrast={theme}>{children}</CustomThemeProvider>;
}
